import {
  CategoryStyleTypes,
  ICategories,
} from "@/api/AppApi/services/home/interfaces/ICategory";
import Category from "./Category";
import { Col, Row } from "../../lib/my-bootstrap";

interface Props extends ICategories {
  isSubCategory: boolean;
  showCategoryImage: boolean;
}

const CategoryGrid = (props: Props) => {
  return (
    <Row className="d-flex justify-content-center" style={{ gap: 16 }}>
      {props.data?.map((child) => (
        <Col className="col-auto p-0" key={child.id}>
          <Category
            customize={props?.configurations?.customize!}
            showCategoryImage={props.showCategoryImage}
            categoryType={
              props.configurations?.style_type ?? CategoryStyleTypes.circle_icon
            }
            {...child}
          />
        </Col>
      ))}
    </Row>
  );
};

export default CategoryGrid;
